module.exports = __webpack_public_path__ + "img/scorecard-4.73ee1358.jpg";